// Generated by CoffeeScript 2.7.0
var ResponsiveTable;

export default ResponsiveTable = {
  props: {
    rows: {
      type: Array,
      default: function() {
        return [];
      }
    },
    headers: {
      type: Array,
      default: function() {
        return [];
      }
    },
    cellWidth: {
      type: Number,
      default: 200
    },
    selectable: {
      type: Boolean,
      default: true
    },
    fixedColumnIds: {
      type: Array,
      default: function() {
        return [];
      }
    },
    enableOperation: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      ignoreScrollEvent: false,
      allSelected: false,
      focusedRow: null,
      hoveredRow: null,
      scrollingClass: {
        'scrolling-y': false,
        'scrolling-x': false
      },
      resizing: false,
      resizeObj: {
        table: null,
        startX: 0,
        startCellWidth: 0,
        startTableWidth: 0,
        _target: {
          header: null,
          body: null
        }
      }
    };
  },
  template: `<div class="datable-table-container" :class='scrollingClass' @mouseleave='removeHoveredRow'>
  <div class="fixed-table" :style="{ width: (Number(selectable) * 60 + cellWidth * fixedHeaders.length) + 'px' }">
    <div class="fixed-table-header">
      <table class="normal-table">
        <colgroup>
          <col width='60px' v-if='selectable' />
          <col v-for='header in fixedHeaders' :key='header.id' :width="cellWidth + 'px'" />
        </colgroup>
        <thead>
          <tr>
            <th class='checkbox-cell' v-if='selectable'>
              <label>
                <input type="checkbox" hidden='true' :checked='allSelected' @change='toggleSelectAll' />
                <i class="slp-square-o"></i>
              </label>
            </th>
            <th v-for='header in fixedHeaders' :key='header.id'>
              <slot name='header' :header='header'>
                <span>{{ header.title }}</span>
              </slot>
            </th>
          </tr>
        </thead>
      </table>
    </div>
    <div class="scroll-container" ref='fixedScrollContainer' @scroll='scrollFixed'>
      <table class="small-table" ref='fixedScrollTable'>
        <colgroup>
          <col width='60px' v-if='selectable' />
          <col v-for='header in fixedHeaders' :key='header.id' :width="cellWidth + 'px'" />
        </colgroup>
        <tbody>
          <template v-for='row in rows'>
            <tr v-for='(tr, index) in row.children'
                :key='tr._uid'
                :class="customRowClass(row)"
                @click='clickRow($event, row, tr)'
                @mouseover='hoverOnRow(row)'>
              <td class="checkbox-cell" v-if='selectable && index === 0'
                                        :rowspan='row.rowspan'
                                        @click.stop>
                <label v-if='row.id'>
                  <input type="checkbox" hidden='true' :checked='row._selected' @change='toggleSelect($event, row)' />
                  <i class='slp-square-o'></i>
                </label>
              </td>
              <td v-for='header in fixedHeaders'
                  :key='header.id'
                  v-if='_getCell(tr, header)'
                  :rowspan='_getCell(tr, header).rowspan'>
                <slot name='body' :cell='_getCell(tr, header)'>
                  <span>单元格</span>
                </slot>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
  <div class="body-table" @scroll='scrollX' @mousemove='handleDrag' @mouseup='handleDragEnd'>
    <div class="body-table-wrapper" :style="{ 'min-width': cellWidth * contentHeaders.length + 'px' }">
      <div class="fixed-table-header">
        <table class="normal-table">
          <colgroup class='header-colgroup'>
            <col v-for='header in contentHeaders' :key='header.id' :style="{ width: cellWidth + 'px' }" />
          </colgroup>
          <thead>
            <tr v-if='contentHeaders.length'>
              <th v-for='(header, index) in contentHeaders' :key='header.id'>
                <div class="th-resizer" @mousedown='handleDragStart($event, index)'></div>
                <slot name='header' :header='header'>
                  <span>{{ header.title }}</span>
                </slot>
              </th>
              <th v-if="enableOperation" width="40px"></th>
            </tr>
            <tr v-else>
              <th></th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="scroll-container" @scroll='scrollBody' ref='bodyScrollContainer'>
        <table class="small-table" ref='bodyScrollTable'>
          <colgroup class="body-colgroup">
            <col class='body-table-column' v-for='header in contentHeaders' :key='header.id' />
          </colgroup>
          <tbody v-if='contentHeaders.length'>
            <template v-for='row in rows'>
              <tr v-for='(tr, index) in row.children'
                  :key='tr._uid'
                  :class="customRowClass(row)"
                  @click='clickRow($event, row, tr)'
                  @mouseover='hoverOnRow(row)'>
                <td v-for='header in contentHeaders'
                    :key='header.id'
                    v-if='_getCell(tr, header)'
                    :rowspan='_getCell(tr, header).rowspan'>
                  <slot name='body' :cell='_getCell(tr, header)'>
                    <span>单元格</span>
                  </slot>
                </td>
                <td v-if="enableOperation" width="40px">
                  <slot name="operation-cell" :row="row"></slot>
                </td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
            <template v-for='row in rows'>
              <tr v-for='(tr, index) in row.children'
                  :key='tr._uid'
                  :class="customRowClass(row)"
                  @click='clickRow($event, row, tr)'
                  @mouseover='hoverOnRow(row)'>
                <td :rowspan='row.rowspan'>
                  <span></span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>`,
  computed: {
    fixedHeaders: function() {
      return _.filter(this.headers, (header) => {
        return _.contains(this.fixedColumnIds, header.id);
      });
    },
    contentHeaders: function() {
      return _.filter(this.headers, (header) => {
        return !_.contains(this.fixedColumnIds, header.id);
      });
    },
    selectedRows: function() {
      return _.filter(this.rows, function(row) {
        return row._selected;
      });
    }
  },
  watch: {
    selectedRows: function() {
      return this.$emit('selectedRowsChanged', this.selectedRows);
    }
  },
  methods: {
    customRowClass: function(row) {
      return {
        'focused': row === this.focusedRow,
        'hovered': row === this.hoveredRow,
        'gray-text': row.read
      };
    },
    toggleSelectAll: function(event) {
      var checked;
      checked = event.target.checked;
      _.each(this.rows, function(row) {
        return row._selected = checked;
      });
      return this.allSelected = checked;
    },
    toggleSelect: function(event, row) {
      var _row, checked;
      checked = event.target.checked;
      _row = _.findWhere(this.rows, {
        id: row.id
      });
      _row._selected = checked;
      if (checked) {
        return this.allSelected = _.chain(this.rows).filter(function(item) {
          return item.id;
        }).every(function(item) {
          return item._selected;
        }).value();
      } else {
        return this.allSelected = false;
      }
    },
    clickRow: function(event, row, child) {
      return this.$emit('rowClicked', event, row, child);
    },
    focusOnRow: function(row) {
      return this.focusedRow = row;
    },
    hoverOnRow: function(row) {
      if (row === this.hoveredRow) {
        return;
      }
      return this.hoveredRow = row;
    },
    removeHoveredRow: function() {
      return this.hoveredRow = null;
    },
    scrollX: function() {
      return this._updateScrollingStatus('x');
    },
    scrollFixed: function() {
      // return 必须能阻止 _syncScrollTop 的调用
      if (this.ignoreScrollEvent) {
        this.ignoreScrollEvent = false;
        return;
      }
      this._updateScrollTop(this.$refs.fixedScrollContainer, this.$refs.bodyScrollContainer);
      return this._syncScrollTop(this.$refs.bodyScrollContainer, this.$refs.fixedScrollContainer);
    },
    scrollBody: function() {
      if (this.ignoreScrollEvent) {
        this.ignoreScrollEvent = false;
        return;
      }
      if (this.selectable) {
        this._updateScrollTop(this.$refs.bodyScrollContainer, this.$refs.fixedScrollContainer);
        return this._syncScrollTop(this.$refs.fixedScrollContainer, this.$refs.bodyScrollContainer);
      }
    },
    handleDragStart: function(event, index) {
      this.resizing = true;
      this._initCorrespondingColumn(DomMaster.wrap(event.target).closest('th'), index);
      this.resizeObj.startX = event.pageX;
      // 记录初始cell宽度
      this.resizeObj.startCellWidth = parseInt(this.resizeObj._target.header.style.width);
      // 记录初始table宽度
      return this.resizeObj.startTableWidth = parseInt(this.resizeObj.table.node.style.minWidth);
    },
    handleDrag: function(event) {
      var delta;
      if (!this.resizing) {
        return;
      }
      delta = event.pageX - this.resizeObj.startX;
      _.each(this.resizeObj._target, (target) => {
        return target.style.width = `${this.resizeObj.startCellWidth + delta}px`;
      });
      return this.resizeObj.table.node.style.minWidth = `${this.resizeObj.startTableWidth + delta}px`;
    },
    handleDragEnd: function(event) {
      if (!this.resizing) {
        return;
      }
      return this.resizing = false;
    },
    scrollTableIntoView: function() {
      return _.each([this.$refs.fixedScrollTable, this.$refs.bodyScrollTable], function(table) {
        return table.scrollIntoView();
      });
    },
    resetAllSelected: function() {
      return this.allSelected = false;
    },
    _initCorrespondingColumn: function(dommaster, index) {
      // 获取resizer对应列的header和body
      this.resizeObj.table = dommaster.closest('.body-table-wrapper');
      this.resizeObj._target.header = this.resizeObj.table.find('.header-colgroup').node.children[index];
      return this.resizeObj._target.body = this.resizeObj.table.find('.body-colgroup').node.children[index];
    },
    _updateScrollTop: function(target, relate) {
      this.ignoreScrollEvent = true;
      this._updateScrollingStatus('y');
      // 设置 scrollTop 后不会立即触发 scroll 事件，会在下一个event loop 之前触发，
      // 所以 @ignoreScrollEvent 应该在事件发生后经判断后重置
      return relate.scrollTop = target.scrollTop;
    },
    _updateScrollingStatus: function(key) {
      var reverseKey;
      reverseKey = key === 'x' ? 'y' : 'x';
      key = `scrolling-${key}`;
      this.scrollingClass[`scrolling-${reverseKey}`] = false;
      if (!this.scrollingClass[key]) {
        this.scrollingClass[key] = true;
      }
      return this._resetScrollStatus(key);
    },
    _syncScrollTop: _.debounce(function(target, relate) {
      // 此 _updateScrollTop 不能再次触发 _syncScrollTop，否则会进入死循环
      // (但不是能使浏览器崩溃的循环, 类似 setInterval(fn, 100))
      return this._updateScrollTop(target, relate);
    }, 100),
    _resetScrollStatus: _.debounce(function(key) {
      return this.scrollingClass[key] = false;
    }, 300),
    _getCell: function(row, header) {
      return _.findWhere(row.cells, {
        cell_id: header.id
      });
    }
  }
};
